<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <b-card title="Welfare Ollipay" class="mr-1 ml-1">
      <h5 class='text-center mt-4'>Scarica l'app Ollipay e utilizza il tuo credito Welfare in ogni momento.</h5>

      <p class='text-center mt-2'>
        Da oggi con <b>Ollipay</b> potrai utilizzare il tuo credito Welfare relativo all'Art51c3 per i tuoi acquisti. Il servizio è pensato per facilitare
        la spesa di tutti i giorni attraverso <b>un'app intuitiva, semplice e funzionale</b> che permette di effettuare transazioni direttamente dal consumatore all'esercente.
      </p>

      <b-row class="mt-4" align-h="center">
        <b-col cols="12" class='text-center'>
          <b-link href="https://ollipay.it/" target="blank"><b-img width="500px" :src="ollipay_logo" fluid alt="ollipay icon"></b-img></b-link>
        </b-col>
      </b-row>

      <h5 class='text-center mt-4'>Scarica subito l'app e utilizza il tuo credito welfare per gli acquisti di tutti i giorni!</h5>

      <b-row class="mt-3" align-h="center">
        <b-col cols="12" md="2" class='text-center'>
          <b-link href="https://play.google.com/store/apps/details?id=wwpay.wellwork.it&hl=it&gl=US" target="blank"><b-img width="250px" :src="google_play_icon" fluid alt="google play icon"></b-img></b-link>
        </b-col>
        <b-col cols="12" md="2" class='text-center'>
          <b-link href="https://apps.apple.com/it/app/ollipay/id1601203063" target="blank"><b-img width="250px" :src="app_store_icon" fluid alt="app store icon"></b-img></b-link>
        </b-col>
      </b-row>

      <p class="mt-5">
        <b>ATTENZIONE:</b> <u>accertati di aver ricevuto le credenziali di accesso</u> all'app prima di scaricarla, se non hai ancora ricevuto i tuoi dati di accesso
        apri un ticket nella nostra <b-link :to="{ 'name' : 'site-assistenza'}" >area assistenza</b-link>.
      </p>

    </b-card>
  </div>
</template>

<script>

import PageTagline from '@/components/PageTagline'

export default {
  name: 'OlliPayStd',
  data () {
    return {
      // La tagline superiore.
      tagline_elem : [ { text : "Ollipay", link : 'conv-ollipay' } ],

      // Icone per lo scaricamento della App e logo Ollipay.
      app_store_icon   : require('@/assets/ollipay/App_Store_Badge_IT.jpg'),
      google_play_icon : require('@/assets/ollipay/Google_Play_Store_badge_IT.jpg'),
      ollipay_logo : require('@/assets/ollipay/ollipay_logo.jpg'),

    }
  },
  components: {
    PageTagline
  }
}
</script>

<style scoped></style>
